import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const Container = lib.styled.div`
`;
export const PaperContainer = lib.styled(Paper)`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 295px;
  max-width: 295px;
  height: 28px;
  background-color: ${colors.white};
  border-radius: 30px!important;
  margin-right: 15px;
  box-shadow: none!important;
  cursor: pointer;

  input {
    padding-left: 10px;
    font-size: 13px;
    font-weight: 500;
  }

  .icon {
    padding-right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;

    div {
      max-height: 20px;
    }
  }
`;

export const InputBaseContainer = lib.styled(InputBase)`
  margin-left: 8;
  flex: 1;

  input {
    padding: 8px 8px 7px!important;
  }
`;
